import { LitElement, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { FontSizes } from '../../../../types/common/types';
import { translateFn } from '../../../../utils/translator.helper';
import { GzLandingPageCompanyType } from '../../../../landingPage/types';
import { getLandingPageReference } from '../../../../landingPage/utils';

/**
 * @summary Type here the description of this component
 * @tag gz-masterclass-widget
 * Here https://custom-elements-manifest.open-wc.org/analyzer/getting-started/ you can find out how to document the code
 */
@customElement('gz-masterclass-widget')
export class MasterclassWebComponent extends LitElement {
  @property({ type: Number })
  companyType: GzLandingPageCompanyType;

  static get styles() {
    return styles;
  }

  render() {
    return html`
      <div class="masterclass-banner">
        <div class="image-container">
          <img src="app/webcomponents/assets/images/landingPage/masterclass_bd.png" />
        </div>
        <div class="data-container">
          <gz-title id="masterclass-title" class="mb-2 header-title" fontSize="${FontSizes.TITLE}"
            ><span>${translateFn('Bitdefender Masterclass')}<span></gz-title
          >
          <gz-text id="masterclass-description" class="fs-14 mb-3">
            ${translateFn(
              'Join us for free in our recurring Masterclass trainings! Access instructor and self-paced technical live webinars to help you become an expert in Bitdefender products and solutions. Each online class is taught by Bitdefender expert cybersecurity professionals with Q&A opportunities.'
            )}</gz-text
          >
          <gz-button
            id="masterclass-go-to-trainings-button"
            class="go-to-trainings-btn"
            type="full"
            color="primary"
            theme="light"
            buttonHeight="medium"
            buttonFontSize="medium"
            @click="${() => this.goToTrainingsBtnAction()}"
            buttonFontSize="medium"
            >${translateFn('go to trainings')}</gz-button
          >
        </div>
      </div>
    `;
  }

  private goToTrainingsBtnAction() {
    try {
      analytics.trackPageInteraction({
        reference: `${getLandingPageReference(this.companyType)}`,
        asset: 'go-to-trainings',
      });
    } finally {
      this.dispatchEvent(
        new Event('go-to-trainings', {
          bubbles: true,
          composed: true,
        })
      );
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-masterclass-widget': MasterclassWebComponent;
  }
}
